import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  initialValue?: string;
  variant?: "light" | "dark";
  autoFocus?: boolean;
  placeholder?: string;
}

export default function SearchBar({
  initialValue = "",
  variant = "light",
  autoFocus = false,
  placeholder = "搜索影视作品 / 资讯关键词",
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const dark = variant === "dark";

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex w-full items-center gap-2 rounded-md border px-3 transition-colors ${
        dark
          ? "border-background-50/30 bg-background-50/10 focus-within:border-accent-400"
          : "border-background-300 bg-background-100 focus-within:border-primary-400"
      }`}
    >
      <div className={`flex h-5 w-5 items-center justify-center ${dark ? "text-background-50/80" : "text-foreground-500"}`}>
        <i className="ri-search-line text-base" />
      </div>
      <input
        type="search"
        value={value}
        autoFocus={autoFocus}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={`h-10 min-w-0 flex-1 bg-transparent text-sm outline-none ${
          dark ? "text-background-50 placeholder:text-background-50/60" : "text-foreground-900 placeholder:text-foreground-500"
        }`}
      />
      <button
        type="submit"
        className={`mr-1 cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
          dark ? "bg-accent-500 text-foreground-950 hover:bg-accent-400" : "bg-primary-500 text-background-50 hover:bg-primary-600"
        }`}
      >
        搜索
      </button>
    </form>
  );
}